import { RouterView } from 'vue-router';

const routes = [
  {
    path: '/orders',
    name: 'Orders',
    component: RouterView,
    children: [
      {
        path: '',
        name: 'Orders List',
        component: () =>
          import(
            /* webpackChunkName: "orders" */ '@/views/orders/pages/orders-list.vue'
          ),
      },
      {
        path: ':id',
        name: 'Order',
        component: () =>
          import(
            /* webpackChunkName: "orders" */ '@/views/orders/pages/orders-single.vue'
          ),
      },
    ],
  },
];

export default routes.map((route) => ({ ...route, meta: {} }));
